import { create } from "zustand";
import type { CameraMode } from "../types/astronomy";

interface SceneStore {
  selectedBodyId: string | null;
  focusedBodyId: string | null;
  cameraMode: CameraMode;
  /** Incrementado a cada foco para forçar reenquadramento da câmera. */
  focusVersion: number;
  /** Fração da altura da viewport que o diâmetro do corpo deve ocupar no foco. */
  focusViewportFraction: number;
  showOrbits: boolean;
  showPlanets: boolean;
  showMoons: boolean;
  showLabels: boolean;
  showAxes: boolean;
  showVelocityVectors: boolean;
  showReferencePlane: boolean;
  fps: number;
  setSelectedBodyId: (id: string | null) => void;
  setFocusedBodyId: (id: string | null) => void;
  setCameraMode: (mode: CameraMode) => void;
  /**
   * Seleciona, foca e pede zoom.
   * @param viewportFraction fração do diâmetro na altura da área (padrão 0.5).
   */
  focusBody: (id: string, viewportFraction?: number) => void;
  setShowOrbits: (value: boolean) => void;
  setShowPlanets: (value: boolean) => void;
  setShowMoons: (value: boolean) => void;
  setShowLabels: (value: boolean) => void;
  setShowAxes: (value: boolean) => void;
  setShowVelocityVectors: (value: boolean) => void;
  setShowReferencePlane: (value: boolean) => void;
  setFps: (fps: number) => void;
}

export const useSceneStore = create<SceneStore>((set) => ({
  selectedBodyId: "earth",
  focusedBodyId: "earth",
  cameraMode: "follow",
  focusVersion: 1,
  focusViewportFraction: 0.2,
  showOrbits: true,
  showPlanets: true,
  showMoons: true,
  showLabels: true,
  showAxes: false,
  showVelocityVectors: false,
  showReferencePlane: true,
  fps: 0,
  setSelectedBodyId: (id) => set({ selectedBodyId: id }),
  setFocusedBodyId: (id) => set({ focusedBodyId: id }),
  setCameraMode: (mode) => set({ cameraMode: mode }),
  focusBody: (id, viewportFraction = 0.5) =>
    set((state) => ({
      selectedBodyId: id,
      focusedBodyId: id,
      cameraMode: "follow",
      focusViewportFraction: viewportFraction,
      focusVersion: state.focusVersion + 1,
    })),
  setShowOrbits: (value) => set({ showOrbits: value }),
  setShowPlanets: (value) => set({ showPlanets: value }),
  setShowMoons: (value) => set({ showMoons: value }),
  setShowLabels: (value) => set({ showLabels: value }),
  setShowAxes: (value) => set({ showAxes: value }),
  setShowVelocityVectors: (value) => set({ showVelocityVectors: value }),
  setShowReferencePlane: (value) => set({ showReferencePlane: value }),
  setFps: (fps) => set({ fps }),
}));
